import React from "react";
import MainTableControls from "./MainTableControls";
import TableCheckboxSelectUsed from "../Table/TableCheckboxSelectUsed";
import { useDealsContext } from "../../context/DealsProvider";
import styled from "styled-components";
import { CONDITIONS } from "../../utils/constants/SYSTEM";
import TableCheckboxSelect from "../Table/TableCheckboxSelect";
import CenterTextStyle from "../Styled/CenterText.style";

export default function MainTable() {
  const [{ dealHeaders, dealRows, condition }] = useDealsContext();

  const { NEW, USED } = CONDITIONS;
  return (
    <MainTableStyle>
      <MainTableControls />
      {condition === NEW ? (
        <TableCheckboxSelect headers={dealHeaders} rows={dealRows} />
      ) : condition === USED ? (
        <TableCheckboxSelectUsed headers={dealHeaders} rows={dealRows} />
      ) : (
        <CenterTextStyle style={{ display: "block", marginTop: "20px" }}>
          <h5>Select a condition to view pre-loaded deals</h5>
        </CenterTextStyle>
      )}
    </MainTableStyle>
  );
}

const MainTableStyle = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
`;
